<template>
  <div class="tw:mb-6">
    <div>
      <div class="required-info tw:text-xs tw:text-gray-700 tw:mb-1" v-html="$t('required_information')" />
      <div>
        <BaseSelect
          id="select-rc-pause-reason"
          :placeholder="$t('rc_pause_flow_menu_prompt')"
          required
          groupedOptions
          :options="reasons"
          display-text-key="label"
          :label="$t('rc_pause_flow_pause_question')"
          @onChange="e => selectReason(e)"
          labelRequiresTranslation
          :value="selectedReason"
        />
      </div>
    </div>
  </div>

  <div v-if="showHint && selectedReasonObject">
    <SmartHintsContainer
      :isItemNetCPAEligible="isItemNetCPAEligible"
      :selectedReasonObject="selectedReasonObject"
      @toggleChangeCampaignModal="toggleChangeCampaignModal"
    />
    <div v-if="selectedReasonObject?.id === 11">
      <p class="tw:font-bold tw:mb-1" v-html="$t('reason_textbox')" />
      <textarea
        class="tw:outline-hidden tw:w-full tw:border tw:border-gray-500 tw:rounded-md tw:p-2 tw:max-h-[150px]"
        :placeholder="$t('rc_pause_flow_other_text_prompt')"
        @input="updateOtherExplanation($event.target.value)"
        :ref="otherExplanation"
        style="height: 56px"
      />
    </div>
  </div>
</template>
<script setup>
import BaseSelect from '@/components/BaseSelect.vue'
import SmartHintsContainer from '@/components/rateConnect/pauseFlow/SmartHintsContainer.vue'

defineProps({
  reasons: Array,
  selectedReason: [String, null],
  selectedReasonObject: [Object, null],
  showHint: Boolean,
  isItemNetCPAEligible: Boolean,
  otherExplanation: String,
})

const emit = defineEmits(['selectReason', 'toggleChangeCampaignModal', 'updateOtherExplanation'])
const toggleChangeCampaignModal = () => emit('toggleChangeCampaignModal')
const updateOtherExplanation = text => emit('updateOtherExplanation', text)
const selectReason = reason => emit('selectReason', reason)
</script>
<style scoped>
.required-info :deep(span) {
  color: var(--tw-color-red-700);
}
p :deep(span) {
  color: var(--tw-color-red-600);
}
</style>
